import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback } from "react";
import { useDispatch } from "react-redux";
import { FilterCard } from "~/components/Filters/FilterCard";
import { clearStringArrayFilterValuesAction, removeFilterAction, setStringArrayFilterValuesAction } from "~/store/filters/actions";
import { selectedStringArrayFiltersSelector } from "~/store/filters/selectors";
import { useAirSelector } from "~/utils/ReduxUtils";
export const StringArrayFilterCard = /*#__PURE__*/ memo((param)=>{
    let { StringSelect, filter, filterCardType, ...props } = param;
    const dispatch = useDispatch();
    const clearValues = useCallback(()=>{
        dispatch(clearStringArrayFilterValuesAction({
            filter
        }));
    }, [
        dispatch,
        filter
    ]);
    const selectedValues = useAirSelector((st)=>selectedStringArrayFiltersSelector(st, filter));
    const onSelectedValuesChange = useCallback((values)=>dispatch(setStringArrayFilterValuesAction({
            values,
            filter
        })), [
        dispatch,
        filter
    ]);
    const onRemoveFilter = (filter)=>{
        dispatch(removeFilterAction({
            filter
        }));
        clearValues();
    };
    return /*#__PURE__*/ _jsx(FilterCard, {
        currentFilter: filterCardType,
        onClearClick: clearValues,
        onRemoveFilter: onRemoveFilter,
        ...props,
        children: /*#__PURE__*/ _jsx(StringSelect, {
            selectedValues: selectedValues,
            onSelectionChange: onSelectedValuesChange
        })
    });
});
StringArrayFilterCard.displayName = "StringArrayFilterCard";
